import { useState } from 'react';
import AdminLayout from './AdminLayout';
import ImageManager from './ImageManager';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('beauty');

  return (
    <AdminLayout>
      <section className="admin-hero">
        <p className="admin-section-label">Gestion de contenido</p>
        <p className="admin-page-copy">
          Administra las galerias publicas, el carrusel principal y la imagen
          de About desde un solo lugar.
        </p>
      </section>

      <section className="admin-panel">
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="admin-tabs"
        >
          <Tab eventKey="beauty" title="Beauty">
            <ImageManager folder="beauty" title="Galeria Beauty" />
          </Tab>
          <Tab eventKey="retratos" title="Retratos">
            <ImageManager folder="retratos" title="Galeria Retratos" />
          </Tab>
          <Tab eventKey="carousel" title="Carrusel">
            <ImageManager folder="carousel" title="Imagenes del carrusel" />
          </Tab>
          <Tab eventKey="about" title="About">
            <ImageManager folder="about" title="Imagen de About" />
          </Tab>
        </Tabs>
      </section>

      <section className="admin-info-card">
        <h2 className="admin-info-title">Notas de uso</h2>
        <ul className="mb-0">
          <li><strong>Subir imagenes:</strong> Usa el boton "Subir imagenes" y selecciona los archivos desde tu computadora.</li>
          <li><strong>Eliminar imagenes:</strong> Usa el boton de papelera sobre cualquier imagen para eliminarla.</li>
          <li><strong>Formatos soportados:</strong> JPG, PNG y WebP, con un maximo de 5 MB por imagen.</li>
          <li>Los cambios impactan directo en el sitio publico segun la carpeta elegida.</li>
        </ul>
      </section>
    </AdminLayout>
  );
}
